import { Building, StateCities } from '../../services/buildings';

export interface BuildingStateInterface {
  cities: StateCities[] | [] | null;
  building: Building | null;
  buildings: Building[] | [] | null;
  query: string | null;
  error: any;
}

export default class BuildingState implements BuildingStateInterface {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public cities: StateCities[] | null = null,
    public building: Building | null = null,
    public buildings: Building[] | null = null,
    public error: any = undefined,
    public query: string = ''
  ) {}
}
